import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-065addea"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "access-denied-page" };
const _hoisted_2 = { class: "panel" };
const _hoisted_3 = { class: "content-area" };
const _hoisted_4 = { class: "denied-container" };
const _hoisted_5 = { class: "denied-card" };
const _hoisted_6 = { class: "icon-blob" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "denied-title" }, "Acceso Restringido", -1 /* HOISTED */));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "denied-message" }, " Lo sentimos, no tienes los permisos necesarios para acceder a este módulo. ", -1 /* HOISTED */));
const _hoisted_9 = { class: "info-box" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Por favor, contacta con tu administrador para solicitar acceso.", -1 /* HOISTED */));
const _hoisted_11 = { class: "actions" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Volver al Inicio", -1 /* HOISTED */));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Regresar", -1 /* HOISTED */));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_ShieldAlertIcon = _resolveComponent("ShieldAlertIcon");
    const _component_InfoIcon = _resolveComponent("InfoIcon");
    const _component_HomeIcon = _resolveComponent("HomeIcon");
    const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("main", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_ShieldAlertIcon, {
                                size: 64,
                                class: "denied-icon"
                            })
                        ]),
                        _hoisted_7,
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_InfoIcon, { size: 20 }),
                            _hoisted_10
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.goToHome && _ctx.goToHome(...args))),
                                class: "btn-home"
                            }, [
                                _createVNode(_component_HomeIcon, { size: 18 }),
                                _hoisted_12
                            ]),
                            _createElementVNode("button", {
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                class: "btn-back"
                            }, [
                                _createVNode(_component_ArrowLeftIcon, { size: 18 }),
                                _hoisted_13
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
